import { Aurelia, autoinject, bindable, bindingMode } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { Config } from 'Config';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { SystemService } from 'DataAccessLayer/Services/SystemService';

@autoinject
export class UserAvatarBaseCustomElement extends BaseCustomElement {

    private _authService: AuthService = null;
    private _aurelia: Aurelia = null;

    constructor(authService: AuthService, aurelia: Aurelia) {
        super();
        this._authService = authService;
        this._aurelia = aurelia;
    }

    get UserInfo() {
        return this._authService.GetUserInfo();
    }

    public async Logout() {
        this._authService.Logout();
        Config.Init();
        await this._authService.LoginAsPublicUser(null);
        await SystemService.Instance.GetSchema();
        window.location.reload();
    }
}